import { type IGraphColors } from '@/version-types';

export const normalizeStrokeDasharray = (dasharray: string, strokeWidth: number) => {
    if (!dasharray) return dasharray;
    const res = dasharray.split(',');
    return res.map((item) => parseFloat((parseFloat(item) * strokeWidth).toFixed(2))).join(',');
};

/**
 * 拍平复杂图形颜色
 *
 * @param colors - 颜色列表
 */
export const flatGraphColors = (colors: IGraphColors[]) => {
    const ret: string[] = [];

    if (!colors || colors.length === 0) return ret;

    colors.forEach((item) => {
        const { color, values } = item;
        values.forEach((val) => {
            ret[val] = color;
        });
    });

    return ret;
};
